import React, { useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faVideo,
    faCommentDots,
    faIdCard,
    faGaugeHigh,
    faEye,
    faPiggyBank,
    faLeaf,
    faGlobe,
} from '@fortawesome/free-solid-svg-icons'
import '../pages/TransformativeImpact.css'

const ADVANTAGES = [
    {
        icon: faVideo,
        title: 'Virtual Hearings',
        text: 'Parties can attend hearings remotely through secure online platforms, ensuring convenience and uninterrupted participation.',
    },
    {
        icon: faCommentDots,
        title: 'Real-Time Communication',
        text: 'Important updates, notices, hearing schedules, and case-related communications are promptly shared through WhatsApp, email, and SMS.',
    },
    {
        icon: faIdCard,
        title: 'Enhanced Accessibility',
        text: 'Multiple communication channels ensure that respondents and claimants remain informed throughout the proceedings and do not miss critical updates.',
    },
    {
        icon: faGaugeHigh,
        title: 'Faster Resolution',
        text: 'Digital processes streamline case management, document exchange, scheduling, and hearing coordination, resulting in quicker dispute resolution.',
    },
    {
        icon: faEye,
        title: 'Transparency and Accountability',
        text: 'Every communication and procedural step is systematically documented, creating a clear and reliable record of proceedings.',
    },
    {
        icon: faPiggyBank,
        title: 'Reduced Costs',
        text: 'Online proceedings significantly minimize travel, administrative, and logistical expenses for all parties involved.',
    },
    {
        icon: faLeaf,
        title: 'Paperless Operations',
        text: 'Digital documentation promotes efficiency while supporting environmentally sustainable practices.',
    },
    {
        icon: faGlobe,
        title: 'Nationwide Reach',
        text: 'Parties, advocates, institutions, and businesses can participate seamlessly regardless of their location.',
    },
]

function TransformativeImpact() {
    const [activeIndex, setActiveIndex] = useState(0)
    const active = ADVANTAGES[activeIndex]
    const detailPanelRef = useRef(null)

    const selectAdvantage = (index) => {
        setActiveIndex(index)
        detailPanelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }

    return (
        <Container fluid className='transformativeContainer'>
            <Row className='justify-content-center'>
                <Col md={10} className='text-center'>
                    <h2 className='transformativeHeading'>Transformative Impact</h2>
                    <p className='transformativeSubheading'>
                        REAA is redefining dispute resolution by integrating technology with legal processes, making
                        arbitration and resolution services more accessible, efficient, and transparent for all
                        stakeholders.
                    </p>
                </Col>
            </Row>

            <Row className='justify-content-center advantageIcons'>
                {ADVANTAGES.map((item, index) => (
                    <Col
                        key={item.title}
                        xs={6}
                        sm={4}
                        md={3}
                        lg={'auto'}
                        className='advantageIconCol'
                        role='button'
                        tabIndex={0}
                        onClick={() => selectAdvantage(index)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                selectAdvantage(index)
                            }
                        }}
                    >
                        <div className={`advantageIconCircle${index === activeIndex ? ' advantageIconCircle--active' : ''}`}>
                            <FontAwesomeIcon icon={item.icon} />
                        </div>
                        <div className='advantageIconLabel'>{item.title}</div>
                    </Col>
                ))}
            </Row>

            <Row className='justify-content-center'>
                <Col md={10}>
                    <div className='advantageDetailPanel' ref={detailPanelRef}>
                        <h3 className='advantageDetailTitle'>{active.title}</h3>
                        <p className='advantageDetailText'>{active.text}</p>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default TransformativeImpact
